import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import * as moment from 'moment';
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
import XLSX from "xlsx";
import { make_cols } from "./MakeColumns";
import { SheetJSFT } from "./types";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import Select from "react-select";
import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import LoadingOverlay from 'react-loading-overlay';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import exportToCSVNew from '../../../Common/exportcsvnew';
import DarkBackground from '../../../Common/backgroundLoader';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import "./styles.css";
/*import Modal from '../../../../shared/components/Modal';*/


var url = window.location.hostname;
var port = window.location.port;



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    //handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.Upload = this.Upload.bind(this);
    //this.ProcessExcel = this.ProcessExcel.bind(this);
    this.handleFile = this.handleFile.bind(this);
  
    this.accessCookie = this.accessCookie.bind(this);
    this.change = this.change.bind(this);
    this.togglePressCancel1 = this.togglePressCancel1.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.toggleFailed1 = this.toggleFailed1.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
    this.ConfirmToggle = this.ConfirmToggle.bind(this);
    this.openConfirm = this.openConfirm.bind(this);
    this.handleFileBefore = this.handleFileBefore.bind(this);
    this.downloadError = this.downloadError.bind(this);
    this.togglePressView = this.togglePressView.bind(this);

    /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
      loading_overlay: false,
      loadingText: "Loading Content..",
      basepack_header: [
        { "Delivery Line Number": "", "Outlet Order No": "", "SKU7 Code": "", "Batch Code": "", "Distributor Code": "", "Unique ID": "", "ASN Reference": "","RS Name":"", "Retailer Code": "", "Retailer HUL Code": "", "Retailer Name": "", "Base Pack Code": "", "Pkd": "", "Order Qty": "", "Stock Allocation date": "", "Salesman Code": "", "Beat Name": "", "MRP": "", "UPC": "", "Beat Seq": "", "Order date": "", "CBU Code": ""},
      ],
      tester_header: [
        { "BasePack Code": "", "Basepack Description": "", "Bin": "" },
      ],
      product_master_header: [
        {
          "Company": "",
          "Brand": "",
          "Sub Brand": "",
          "LB SKU ID": "",
          "LB SKU Product Name": "",

          "Basepack Code": "",
          "BasePack Description": "",
          "CBU Code": "",
          "Shade Code": "",
          "Shade Name": "",
          "Category": "",
          "Sub-Category": "",
          "Price Lot": "",
          "MRP": "",
          "UOM": "",
          "UPC": "",
          "Pack Size": "",
          "Pack Size UOM": "",
          "EAN": "",
          "ICLD EAN": "",
      "Tester Code":"",
          "Weight": "",
          "Volume": "",
          "ICLD Volume": "",
          "SKU7 Code": "",
          "SKU5 Code": "",
          "Offer": "",
          "Tester": "",
          "Tester Ratio": "",
          "Storage Type": "",
          "Shelf Life (months)": "",
          "Status": "",
          "Created Date Time": "",
          "Barcode type": "",
          "CBU Tester Flag": "",
          "ICLD Width": "",
          "ICLD Height": "",
          "ICLD Depth": "",
          "OCLD EAN": "",
          "CPO": "",
          "OCLD Depth": "",
          "OCLD Flag": "",
          "OCLD Height": "",
          "OCLD Volume": "",
          "OCLD Width": "",
          "LB Type": "",
          "LB Type Analysis": "",
          "Updated Date Time": "",
          "Created By": "",
          "Updated By": "",
          "ID": "",
          "ICLD EAN Verified Status": "",
          "ICLD EAN Verified Date/Time": "",
          "OCLD EAN Verified Status": "",
          "OCLD EAN Verified Date/Time": "",
          "Reference LB SKU ID": "",
        },
      ],
      bin_master_header: [
        {
          "Storage type": "",
          "Aisle": "",
          "Rack": "",
          "Rack type": "",
          "Level": "",
          "Bin": "",
          "Bin Address": "",
          "Bin Volume": "",
          "Zone Name": "",
          "Zone No.": "",
          "Rack Address": "",
          "Bin Depth": "",
          "Bin Width": "",
          "Bin Height": "",
        },
      ],
      showPassword: false,
    responseModal: false,
    responseModalMsg: null,
    btnDisabled: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem: false,
      showInvalidProductItem: false,
      fileNameVal: "masterFile",
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      btnDisabled1: true,
      btnDisabled2: true,
      btnDisabled3: true,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      totalCount: "",
      selectedOption: null,
      posts: [],
      postsBase: [],
      postsProduct: [],
      postsTester: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      batch_id: "",
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      modalFailed1: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,

      isLoading: true,
      showFetchBinData: false,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      BinMasters: [
        "Aisle",
        "Bin",
        "Bin Address",
        "Level",
        "Rack",
        "Rack Type",
        "Storage Type",
        "Zone Name",
        "Zone No.",
      ],
      /*BasePackCodes:["Base Pack Code" , "Zone Name" , "Zone No"],*/

      BasePackCodes: [
        { "Base Pack Code": "fghj", "Zone Name": "fghj", "Zone No": "fghj" },
      ],
      zoneTypeDropdown: [],
      zoneConfigDropdown: [],
      configBaskPackDropdown: [],
      config_zonecode: null,
      config_zonename: null,
      config_zonetype: null,
      config_zoneconfig: null,
      config_basepackcode: null,
      config_producttype: null,
      showZoneConfigCard: false,
      zoneOptions: [],
      validation: {
        "Bin Master": {
          Aisle: "string",
          Bin: "number",
          "Bin Address": "string",
          Level: "number",
          Rack: "number",
          "Rack type": "string",
          "Storage type": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Basepack Zone": {
          "Base Pack Code": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Product Master": {
          Company: "string",
          Brand: "number",
          "Sub Brand": "string",
          "LB SKU ID": "number",
          "LB SKU Product Name": "number",
          "Basepack Code": "string",
          "CBU Code": "string",
          "Shade Code": "string",
          "Shade Name": "number",
          Category: "string",
          "Sub-Category": "string",
          "Price Lot": "string",
          MRP: "string",
          UOM: "string",
          UPC: "string",
          "Pack Size": "string",
          "Pack Size UOM": "string",
          EAN: "string",
          "ICLD EAN": "string",
          Weight: "string",
          Volume: "string",
          "ICLD Volume": "string",
          "SKU7 Code": "string",
          "SKU5 Code": "string",
          Offer: "string",
          Tester: "string",
          "Storage Type": "string",
          Status: "string",
          "Created Date Time": "string",
          "Updated Date Time": "string",
        },

        "Tester Basepack Master": {
          "S. No.": "number",
          "BasePack Code": "string",
          "Basepack Description": "string",
          Bin: "string",
        },
      },
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  responseModalToggle = () => {
  this.setState({
    responseModal: !this.state.responseModal
  });
  }

  togglePressView(){
   //this.props.history.push('/secondaryupload/view')
   //this.props.history.push("/secondaryupload/view");
   //window.location.href = '/secondaryupload/view'
   window.open('/secondaryupload/view','_blank');
  }

   downloadError = () => {

    const payload = {
      location: this.state.selectedLocation,
      batch_id: this.state.batch_id,
  };
addAnalytics('Order Upload', 'Order Download Err', payload);
API.post('/product/product_master/v1/error/report/', { param: payload })
      .then((response) => response.data) 
       .then((data) => {
        console.log(data);
        window.location.href = data.data[0]
      })
      .catch(function (error) {});
  };
  
  config_zoneDropDown = () => {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/inventory/fetchZoneConfigType/v1/', { param: payload })
      .then((response) => response.data)
    .then((data) => {
        this.setState({
      zoneTypeDropdown: data["zone_types"],
            zoneConfigDropdown: data["zone_config"],
            configBaskPackDropdown: data["base_pack_codes"],
    });
      })
      .catch(function (error) {});
  };

  configOnChangeHandler = (e) => {
    if(e.target.name === "config_zonecode"){
    this.setState({config_zonecode: e.target.value});
  }if(e.target.name === "config_zonename"){
    this.setState({config_zonename: e.target.value});
  }if(e.target.name === "config_zonetype"){
    this.setState({config_zonetype: e.target.value});
  }if(e.target.name === "config_zoneconfig"){
    this.setState({config_zoneconfig: e.target.value});
  }if(e.target.name === "config_basepackcode"){
    this.setState({config_basepackcode: e.target.value});
  }if(e.target.name === "config_producttype"){
    this.setState({config_producttype: e.target.value});
  }
  }

  zoneDropdown = () => {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/cycle_count/cycleCountParameters/v1/', { param: payload })
      .then((response) => response.data) 
       .then((data) => {
        let zoneOptions = [...this.state.zoneOptions];
        for (var i = 0; i < data.zones.length; i++) {
          var orderData = {};
          orderData["label"] = data.zones[i].zone_code;
          orderData["value"] = data.zones[i].zone_no;
          orderData["id"] = data.zones[i].id;
          zoneOptions.push(orderData);
        }
        this.setState({
          zoneOptions: zoneOptions,
        }, () => {console.log(this.state.zoneOptions)});
      })
      .catch(function (error) {});
  };
  createZoneConfig = () => {
    if(this.state.config_zonecode === "" || this.state.config_zonecode === undefined){
    alert("Enter Zone Code");
        return false;
    }
    if(this.state.config_zonename === "" || this.state.config_zonename === undefined){
    alert("Enter Zone Name");
        return false;
    }
    if(this.state.config_zonetype === 0 || this.state.config_zonetype === undefined){
    alert("Select Zone Type");
        return false;
    }
    if(this.state.config_zoneconfig === 0 || this.state.config_zoneconfig === undefined){
    alert("Select Zone Config");
        return false;
    }
    if(this.state.config_basepackcode === 0 || this.state.config_basepackcode === undefined){
    alert("Select BasePack code");
        return false;
    }
    if(this.state.config_producttype === "" || this.state.config_producttype === undefined){
    alert("Select Product Type");
        return false;
    }
    const payload = {
      location: this.state.selectedLocation,
      zone_type_id: this.state.config_zonetype,
      zone_config_id: this.state.config_zoneconfig,
      zone_name: this.state.config_zonename,
      zone_no: this.state.config_zonecode,
      base_pack_code: this.state.config_basepackcode,
      product_type: this.state.config_producttype
  };

API.post('/inventory/zoneCreation/v1/', { param: payload })
      .then((response) => response.data)
    .then((data) => {
        if(data.status === true){
            this.setState({successCreatedMessage: "Updated Successfully",Successmodal: true})
        }
      })
      .catch(function (error) {});
  };
  /*onMasterChange(event){
    this.setState({
      value: event.target.value
    })
    console.log(this.state.value);

  }*/

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8090";
    } else {
      url = window.location.hostname+port;
    }

    var cookieUsername = this.getCookie("token");
    var location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: location,
      },
      () => {
        //this.config_zoneDropDown();
        //this.zoneDropdown();
      }
    );

    localStorage.setItem("userName", username);
  }

  

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  SuccesstoggleCancel() {
    this.setState(
      {
        Successmodal: false,
      }/*,
      () => {
        if (document.getElementById("my_file_input") !== null) {
          document.getElementById("my_file_input").style.color = "transparent";
          document.getElementById("tester_label").style.display =
            "inline-block";
          document.getElementById("tester_label").innerHTML =
            "Select and Upload Master ";
      document.getElementById("my_file_input").style.width = "26%";
        }
        $(".upload_error").css("display", "none");
        $(".upload_success").css("display", "none");
      }*/
    );

    /*if (this.state.selectedOption.value === "bin_master") {
          this.fetchBinData();
          

      } else if (this.state.selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          

      } else if (this.state.selectedOption.value === "product_master") {
          this.fetchProductData();
          

      }*/
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  toggleFailed1() {
    this.setState((prevState) => ({ modalFailed1: !prevState.modalFailed1 }));
  }

  ConfirmToggle() {
    this.setState((prevState) => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm() {
    this.setState({
      ConfirmModal: true,
    });
  }

  togglePressCancel() {
    
    this.setState({
      modal: false,
      modalFailed: false,
    });
  }

  togglePressCancel1() {
    
    this.setState({
      //modal: false,
      modalFailed1: false,
    });
  }


  
 

  handleChange(evt) {
  const files = evt.target.files;
  var file1 = evt.target.value;
  this.setState({
    btnDisabled: true,
        loading_overlay: true,
  }, () => {
    
    if (files && files[0]) {
    this.setState({ 
    file: files[0] 
    })
  }else{
    this.setState({ 
    loading_overlay: false,
        btnDisabled: false,
        file:{},
    })
        $(".upload_success").css('display', 'none');
      $(".upload_error").css('display', 'none');
      $('.button_enable').removeAttr('disabled','disabled');
        return false;
  };
    
    var fileArray1 = file1.split(".");
    var extension1 = fileArray1[fileArray1.length - 1];

    if (document.getElementById("my_file_input") !== null) {
      document.getElementById("my_file_input").style.color = "";
      document.getElementById("my_file_input").style.width = "85%";
      document.getElementById("picking_label").style.display = "none";
    }else{
      document.getElementById("my_file_input").style.width = "26%";
    }

    if (extension1 != "xlsx" && extension1 != "csv" && extension1 != "xls") {
      $(".upload_error").css("display", "block");
      $(".upload_success").css("display", "none");
    } else {
      $(".upload_success").css("display", "block");
      $(".upload_error").css("display", "none");
      $(".button_enable").removeAttr("disabled", "disabled");
    }
    
    this.setState({
      btnDisabled: false,
            loading_overlay: false,
    });
  });
  }

  change = (selectedOption) => {
    this.setState({
      selectedOption,
      selectedFileType: selectedOption.label,
      showInvalidProductItem: false,
      showInvalidTesterItem: false,
      showRowDataErrorProduct: false,
      showRowDataErrorTester: false,
      showInvalidBaseItem: false,
      showRowDataErrorBase: false,
      showRowDataError: false,
      showInvalidItem: false,
      showZoneConfigCard: false,
    });
    $(".upload_error").css("display", "none");
    $(".upload_success").css("display", "none");
    $(".fileControl").val("");

    if (selectedOption.value === "bin_master") {
      //this.fetchBinData();
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchTesterData: false,
        showFetchProductData: false,
      });
    } else if (selectedOption.value === "base_pack_zone") {
      //this.fetchBaseData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: true,
        showFetchProductData: false,
        showFetchTesterData: false,
        showZoneConfigCard: true
      });
    } else if (selectedOption.value === "product_master") {
      //this.fetchProductData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: false,
        showFetchProductData: true,
        showFetchTesterData: false,
      });
    } else if (selectedOption.value === "tester_basepack_master") {
      //this.fetchTesterData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: true,
      });
    }

    console.log(`Option selected:`, selectedOption.value);
  };

  validateItem = (item) => {
    const { selectedFileType, validation } = this.state;
    const dataTypes = validation[selectedFileType];
    if (dataTypes === undefined) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
    const keyNames = Object.keys(dataTypes);
    if (Object.keys(item).length !== keyNames.length) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
    /*if(Object.keys(item).filter(key => (keyNames.indexOf(key) === -1)).length){
      this.setState({
        error: "Invalid header of data uploaded. Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }
    if(Object.keys(item).filter(key => (typeof item[key] !== dataTypes[key])).length){
      this.setState({
        error: "Invalid datatype of data uploaded.Below data are invalid. Please Upload a valid file formate"
      })
      return false
    }*/
    return true;
  };

   dateformatHandler1 = (str) => {
     var date = new Date(str),
        mnth = ("0" + (date.getMonth()+1)).slice(-2),
        day  = ("0" + date.getDate()).slice(-2);
        var hour  = ("0" + date.getHours()).slice(-2);
        var minute = ("0" + date.getMinutes()).slice(-2);
        return [ date.getFullYear(), mnth, day, hour, minute ].join("-");
   }



  dateformatHandler = (date,flag) => {
  //var parsed_stnDate = Date.parse(date);
  const d1 = new Date(date);
  let year = d1.getFullYear().toString().substr(0);
  let day = d1.getDate();
  let month = d1.getMonth()+1;
    let hour = d1.getHours();
  let minutes = d1.getMinutes();
  if(day.toString().length == 1){
    day = "0"+day;
  }

  if(month.toString().length == 1){
    month = "0"+month;
  }

  if(flag === true){
    return year+"-"+month+"-"+day+" "+hour+":"+minutes;
  }else{
    return day+"-"+month+"-"+year;
  }
  
}



  
handleFile() {
    /* Boilerplate to set up FileReader */
    this.Upload(this.state.file, this.state.file.name)
    return false;

    var manifestPayload;
   
  if(this.state.file.name === undefined || this.state.file.name === null){
    this.setState({
      responseModal: true,
      responseModalMsg: "Select at least one File"
    });
    return false;
    }
    this.setState({
      loading2: true,
      loading: false,
       loadingText: 'Data is getting uploaded',
      loading_overlay: true,
    });


    //Reference the FileUpload element.
        var fileUpload = this.state.file
        //Validate whether File is valid Excel file.
        var fExt =  this.state.file.name.split('.').pop();
        var extArray = ["xls","xlsx","csv"]
        if (extArray.indexOf(fExt) > -1) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();

                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                        //this.ProcessExcel(e.target.result);
                        var workbook = XLSX.read(e.target.result, {
                            type: 'binary',
                            cellDates: true,
                            cellNF: false,
                            cellText: false
                        });

                        //Fetch the name of First Sheet.
                        var firstSheet = workbook.SheetNames[0];
                        var xlsxWorkbook = workbook
                        //Read all rows from First Sheet into an JSON array.
                        var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet], {defval:""});

                        //Create a HTML Table element.
                        console.log(excelRows)
                        manifestPayload = excelRows
                        console.log(manifestPayload)
                        console.log(new Date(manifestPayload[0]['Order date']))
                    };
                    reader.readAsBinaryString(this.state.file);
                } else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        //this.ProcessExcel(data);
                    };
                    reader.readAsArrayBuffer(this.state.file);
                }
            } else {
                alert("This browser does not support HTML5.");
            }
        } else {
            alert("Please upload a valid Excel file.");
        }
  const ref = this;
    const reader1 = new FileReader();
    const rABS = !!reader1.readAsBinaryString;

    reader.onload = (e) => {
     
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' , cellDates: true, cellNF: true, cellText: true });
     
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      
      const data1 = XLSX.utils.sheet_to_json(ws)
       console.log('json_object', data1);
      
    var XL_row_object = XLSX.utils.sheet_to_row_object_array(
          wb.Sheets[wsname],
          { header: 1, blankRows: false }
        );
      var json_object = XL_row_object;
      console.log("XL_row_object",XL_row_object)

     

      
      var mandatory_field = false;
    var uploaded_file_header = json_object[0];

      /* if (this.state.selectedOption.value === "product_master") {
    var sample_file_header = Object.keys(this.state.product_master_header[0]);
    }else if (this.state.selectedOption.value === "base_pack_zone") {
    var sample_file_header = Object.keys(this.state.basepack_header[0]);
    }else if (this.state.selectedOption.value === "tester_basepack_master") {
    var sample_file_header = Object.keys(this.state.tester_header[0]);
    }else if (this.state.selectedOption.value === "bin_master") {
    var sample_file_header = Object.keys(this.state.bin_master_header[0]);
    } */

    var sample_file_header = Object.keys(this.state.basepack_header[0]);
    
    if(parseInt(uploaded_file_header.length) !== parseInt(sample_file_header.length) ){
      ref.setState({
          loading: false,
          responseModal: true,
          responseModalMsg: "Invalid Format Encountered- The file input should be in the same format as the template provided",
          loading_overlay: false,
        });
        /*if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
        document.getElementById("my_file_input").style.width = "26%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');*/
        return false;
    } 
    for (let i = 0; i < uploaded_file_header.length; i++){
      if (uploaded_file_header[i] !== sample_file_header[i]){
       ref.setState({
          loading: false,
          responseModal: true,
          responseModalMsg: "Invalid Format",
                    loading_overlay: false,
        });
      return false;
      }
    }
      
      /* Update state */
      this.setState({ data: manifestPayload, cols: make_cols(ws["!ref"]) }, () => {
        let invalidItems = this.state.data.filter(
          (item) => !this.validateItem(item)
        );
        /*if(invalidItems.length > 0){

          console.log("Invalid Items", invalidItems)
          this.setState({
            showInvalidItem: true,
            showResponseData: true,
            invalidItemList: invalidItems

          })
        }else{
          console.log("Valid items");
           this.setState({
            showInvalidItem: false,

          })*/

        //if (this.state.selectedOption.value === "base_pack_zone") {
          if (invalidItems.length > 0) {
            console.log(invalidItems);
            this.setState({
              showRowDataErrorBase: false,
              showRowDataErrorProduct: false,
              showRowDataErrorTester: false,
              showRowDataError: false,
              showResponseData: true,
              ErrorRowData: invalidItems,
              showResponseData: false,
              showInvalidItem: false,
              showBaseResponseData: false,
              showInvalidBaseItem: false,
              showInvalidProductItem: false,
              showInvalidTesterItem: false,
              showProductResponseData: false,
              showFetchBaseData: false,
              showFetchProductData: false,
              showFetchTesterData: false,
              showFetchBinData: false,
            });

            console.log(Object.keys(invalidItems));
            /*alert(indexOfExt(this.state.BasePackCodes, invalidItems));*/

            /*return false*/
          }

          console.log(this.state.data.length);
          addAnalytics('Order Upload', 'Order Upload', payload);
          var arr = [];

          for (var i = 0; i < this.state.data.length; i++) {
            // <---- Move declaration inside loop


            this.state.data[i]['Order date'] = this.dateformatHandler(this.state.data[i]['Order date'],true);
            console.log("ORDERDATE===>>.", this.state.data[i]['Order date']);
            var orderData = {};
           /*orderData["basePackCode"] = this.state.data[i]["BasepackCode"];
            orderData["zoneName"] = this.state.data[i]["ZoneName"];
            orderData["zoneNo"] = this.state.data[i]["ZoneNo"];*/

            // this.state.data[i]['Order date'] = moment(this.state.data[i]['Order date'], 'DD/MM/YY').format('DD-MM-YY HH:MM')

            if(this.state.data[i]["Delivery Line Number"] == undefined || this.state.data[i]["Delivery Line Number"] == null){
              alert("ASN Reference cannot be empty value");
              return false;
              orderData["delivery_line_number"]= "";
            }else{
              orderData["delivery_line_number"] = this.state.data[i]["Delivery Line Number"];
            }

            if(this.state.data[i]["Outlet Order No"] == undefined || this.state.data[i]["Outlet Order No"] == null){
                
              orderData["outlet_order_no"]= "";
               
            }else{
              orderData["outlet_order_no"] = this.state.data[i]["Outlet Order No"];
            }

            if(this.state.data[i]["SKU7 Code"] == undefined || this.state.data[i]["SKU7 Code"] == null){
              orderData["sku7_code"]= "";
            }else{
              orderData["sku7_code"] = this.state.data[i]["SKU7 Code"];
            }

            if(this.state.data[i]["Batch Code"] == undefined || this.state.data[i]["Batch Code"] == null){
              orderData["batch_code"]= "";
            }else{
              orderData["batch_code"] = this.state.data[i]["Batch Code"];
            }

            if(this.state.data[i]["Distributor Code"] == undefined || this.state.data[i]["Distributor Code"] == null){
              orderData["distributor_code"]= "";
            }else{
              orderData["distributor_code"] = this.state.data[i]["Distributor Code"];
            }

            if(this.state.data[i]["Unique ID"] == undefined || this.state.data[i]["Unique ID"] == null){
              orderData["unique_id"]= "";
            }else{
              orderData["unique_id"] = this.state.data[i]["Unique ID"];
            }

            if(this.state.data[i]["ASN Reference"] == undefined || this.state.data[i]["ASN Reference"] == null){
              alert("ASN Reference cannot be empty value")
              orderData["asn_reference"]= "";
            }else{
              orderData["asn_reference"] = this.state.data[i]["ASN Reference"];
            }

            if(this.state.data[i]["RS Name"] == undefined || this.state.data[i]["RS Name"] == null){
              orderData["rs_name"]= "";
            }else{
              orderData["rs_name"] = this.state.data[i]["RS Name"];
            }

            if(this.state.data[i]["Retailer Code"] == undefined || this.state.data[i]["Retailer Code"] == null){
              orderData["retailer_code"]= "";
            }else{
              orderData["retailer_code"] = this.state.data[i]["Retailer Code"];
            }

            if(this.state.data[i]["Retailer HUL Code"] == undefined || this.state.data[i]["Retailer HUL Code"] == null){
              orderData["retailer_hul_code"]= "";
            }else{
              orderData["retailer_hul_code"] = this.state.data[i]["Retailer HUL Code"];
            }

            if(this.state.data[i]["Retailer Name"] == undefined || this.state.data[i]["Retailer Name"] == null){
              orderData["retailer_name"]= "";
            }else{
              orderData["retailer_name"] = this.state.data[i]["Retailer Name"];
            }

            if(this.state.data[i]["Base Pack Code"] == undefined || this.state.data[i]["Base Pack Code"] == null){
              orderData["base_pack_code"]= "";
            }else{
              orderData["base_pack_code"] = this.state.data[i]["Base Pack Code"];
            }

            if(this.state.data[i]["Pkd"] == undefined || this.state.data[i]["Pkd"] == null){
              orderData["pkd"]= "";
            }else{
              orderData["pkd"] = this.state.data[i]["Pkd"];
            }

            if(this.state.data[i]["Order Qty"] == undefined || this.state.data[i]["Order Qty"] == null){
              orderData["order_qty"]= "";
            }else{
              orderData["order_qty"] = this.state.data[i]["Order Qty"];
            }

            if(this.state.data[i]["Stock Allocation date"] == undefined || this.state.data[i]["Stock Allocation date"] == null){
              orderData["stock_allocation_date"]= "";
            }else{
              orderData["stock_allocation_date"] = this.state.data[i]["Stock Allocation date"];
            }

            if(this.state.data[i]["Salesman Code"] == undefined || this.state.data[i]["Salesman Code"] == null){
              orderData["salesman_code"]= "";
            }else{
              orderData["salesman_code"] = this.state.data[i]["Salesman Code"];
            }

            if(this.state.data[i]["Beat Name"] == undefined || this.state.data[i]["Beat Name"] == null){
              orderData["beat_name"]= "";
            }else{
              orderData["beat_name"] = this.state.data[i]["Beat Name"];
            }

            if(this.state.data[i]["MRP"] == undefined || this.state.data[i]["MRP"] == null){
              orderData["mrp"]= "";
            }else{
              orderData["mrp"] = this.state.data[i]["MRP"];
            }

            if(this.state.data[i]["UPC"] == undefined || this.state.data[i]["UPC"] == null){
              orderData["upc"]= "";
            }else{
              orderData["upc"] = this.state.data[i]["UPC"];
            }

            if(this.state.data[i]["Beat Seq"] == undefined || this.state.data[i]["Beat Seq"] == null){
              orderData["beat_seq"]= "";
            }else{
              orderData["beat_seq"] = this.state.data[i]["Beat Seq"];
            }

            if(this.state.data[i]["Order date"] == undefined || this.state.data[i]["Order date"] == null){
              orderData["order_date"]= "";
            }else{
              orderData["order_date"] = this.state.data[i]["Order date"];
            }

            if(this.state.data[i]["CBU Code"] == undefined || this.state.data[i]["CBU Code"] == null){
              orderData["cbu_code"]= "";
            }else{
              orderData["cbu_code"] = this.state.data[i]["CBU Code"];
            }


            



            arr.push(orderData);
          }

          console.log(arr);
          var arr_data = JSON.stringify(arr);
          //return false;


              const payload={
                  data: arr,
                  //master_type: "retailer_master",
                  location: this.state.selectedLocation,
              }
            API.post('/product/product_master/v1/upload/', { param: payload })
            .then((response) => {
              console.log("responeData",response.data);


              this.setState({
                //showBaseResponseData: true,
                showInvalidBaseItem: false,
                showInvalidTesterItem: false,
                showTesterResponseData: false,
                loading: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                //showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                //showInvalidProductItem: true,
                responseFailProductData: response.data.data,
                showRowDataErrorTester: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                //show_process_data: true,
                loadingText: 'Data is getting Proccessed',
                loading_overlay: true,
              });

              if(response.data.success == false){
                this.toggleFailed();
              }else{
                //this.Successtoggle();
                this.setState({
                 successCreatedMessage: response.data.message,
                 loading_overlay: false,
                 loading_overlay2: true,
                })

                 axios.get('http://'+url+'/product/product_master/v1/process/',

                    {
                         headers: {
                              'Content-Type': 'application/json',
                              'Authorization' : this.state.userName
                              
                            } 

                       }
                    )

                  .then(response => response.data)

                  .then(data => {

                     console.log("PROCESS DATA",data);
                     this.setState({
                       //successCreatedMessage: response.data.message,
                       loading_overlay: false,
                       loading_overlay2: false,
                       loading2: false,
                       loading: false,

                      })

                      if(data.success == true){
                        this.toggleFailed1();
                        localStorage.setItem('batch_id', data.batch_id)
                        var total_count = data.success_count + data.failure_count
                        this.setState({
                          failCreatedMessage: 'Data is ready for planning',
                          batch_id: data.batch_id,
                          successCount: data.success_count,
                          failCount: data.failure_count,
                          totalCount: total_count,
                          btnDisabled2: false,
                          btnDisabled3: false,
                          btnDisabled1: true,

                 
                        })

                      }else{
                      this.toggleFailed1();
                      }


                     // if (err) throw err;

                     //this.setState({ loading_overlay:false,posts: data })

                  })

                  .then(async() => {

                     //this.setState({ tableRows:this.assemblePosts(), isLoading:false })

                     //console.log(this.state.tableRows);

                  });
              }

              /*if (response.data.failure_response.length > 0) {
                this.toggleFailed();
              } else {
                this.toggle();
              }

              if (response.data.success_response.length > 0) {
                this.setState({
                  show_process_data: true,
                });
              } else {
                this.setState({
                  show_process_data: false,
                });
              } */
                this.setState({loading_overlay: false,})
        if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
        document.getElementById("my_file_input").style.width = "26%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
              /*this.fetchBaseData();*/
            })
            .catch(function (error) {
              
        if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
      
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
      });
       

        

        

       

        /*}*/
      });
    };

    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  }



  Upload(file, fileName) {
          this.setState({
            loadingText: 'Data is getting uploaded',
            loading_overlay: true,
          })
        //Reference the FileUpload element.
        var manifestPayload;
        var fileUpload = file
        //Validate whether File is valid Excel file.
        var fExt = fileName.split('.').pop();
        var extArray = ["xls","xlsx","csv"]
        if (extArray.indexOf(fExt) > -1) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();

                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    var ref = this;
                    reader.onload = function (e) {
                        //this.ProcessExcel(e.target.result);
                        var workbook = XLSX.read(e.target.result, {
                            type: 'binary',
                            cellDates: true,
                            cellNF: false,
                            cellText: false
                        });

                        //Fetch the name of First Sheet.
                        var firstSheet = workbook.SheetNames[0];
                        var xlsxWorkbook = workbook
                        //Read all rows from First Sheet into an JSON array.
                        var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet], {defval:""});

                        //Create a HTML Table element.
                        console.log(excelRows)
                         manifestPayload = excelRows
                        //console.log(manifestPayload)
                        console.log("Coverted",ref.dateformatHandler(manifestPayload[0]['Order date'], true))
                        ref.setState({data: excelRows})
                        console.log(new Date(manifestPayload[0]['Order date']))

                        var arr = [];

          for (var i = 0; i < excelRows.length; i++) {
            // <---- Move declaration inside loop


            excelRows[i]['Order date'] = ref.dateformatHandler(excelRows[i]['Order date'],true);
            console.log("ORDERDATE===>>.", excelRows[i]['Order date']);
            var orderData = {};
           /*orderData["basePackCode"] = this.state.data[i]["BasepackCode"];
            orderData["zoneName"] = this.state.data[i]["ZoneName"];
            orderData["zoneNo"] = this.state.data[i]["ZoneNo"];*/

             

            if(excelRows[i]["Delivery Line Number"] == undefined || excelRows[i]["Delivery Line Number"] == null){
              alert("ASN Reference cannot be empty value");
              return false;
              orderData["delivery_line_number"]= "";
            }else{
              orderData["delivery_line_number"] = excelRows[i]["Delivery Line Number"];
            }

            if(excelRows[i]["Outlet Order No"] == undefined || excelRows[i]["Outlet Order No"] == null){
                
              orderData["outlet_order_no"]= "";
               
            }else{
              orderData["outlet_order_no"] = excelRows[i]["Outlet Order No"];
            }

            if(excelRows[i]["SKU7 Code"] == undefined || excelRows[i]["SKU7 Code"] == null){
              orderData["sku7_code"]= "";
            }else{
              orderData["sku7_code"] = excelRows[i]["SKU7 Code"];
            }

            if(excelRows[i]["Batch Code"] == undefined || excelRows[i]["Batch Code"] == null){
              orderData["batch_code"]= "";
            }else{
              orderData["batch_code"] = excelRows[i]["Batch Code"];
            }

            if(excelRows[i]["Distributor Code"] == undefined || excelRows[i]["Distributor Code"] == null){
              orderData["distributor_code"]= "";
            }else{
              orderData["distributor_code"] = excelRows[i]["Distributor Code"];
            }

            if(excelRows[i]["Unique ID"] == undefined || excelRows[i]["Unique ID"] == null){
              orderData["unique_id"]= "";
            }else{
              orderData["unique_id"] = excelRows[i]["Unique ID"];
            }

            if(excelRows[i]["ASN Reference"] == undefined || excelRows[i]["ASN Reference"] == null){
              alert("ASN Reference cannot be empty value")
              orderData["asn_reference"]= "";
            }else{
              orderData["asn_reference"] = excelRows[i]["ASN Reference"];
            }

            if(excelRows[i]["RS Name"] == undefined || excelRows[i]["RS Name"] == null){
              orderData["rs_name"]= "";
            }else{
              orderData["rs_name"] = excelRows[i]["RS Name"];
            }

            if(excelRows[i]["Retailer Code"] == undefined || excelRows[i]["Retailer Code"] == null){
              orderData["retailer_code"]= "";
            }else{
              orderData["retailer_code"] = excelRows[i]["Retailer Code"];
            }

            if(excelRows[i]["Retailer HUL Code"] == undefined || excelRows[i]["Retailer HUL Code"] == null){
              orderData["retailer_hul_code"]= "";
            }else{
              orderData["retailer_hul_code"] = excelRows[i]["Retailer HUL Code"];
            }

            if(excelRows[i]["Retailer Name"] == undefined || excelRows[i]["Retailer Name"] == null){
              orderData["retailer_name"]= "";
            }else{
              orderData["retailer_name"] = excelRows[i]["Retailer Name"];
            }

            if(excelRows[i]["Base Pack Code"] == undefined || excelRows[i]["Base Pack Code"] == null){
              orderData["base_pack_code"]= "";
            }else{
              orderData["base_pack_code"] = excelRows[i]["Base Pack Code"];
            }

            if(excelRows[i]["Pkd"] == undefined || excelRows[i]["Pkd"] == null){
              orderData["pkd"]= "";
            }else{
              orderData["pkd"] = excelRows[i]["Pkd"];
            }

            if(excelRows[i]["Order Qty"] == undefined || excelRows[i]["Order Qty"] == null){
              orderData["order_qty"]= "";
            }else{
              orderData["order_qty"] = excelRows[i]["Order Qty"];
            }

            if(excelRows[i]["Stock Allocation date"] == undefined || excelRows[i]["Stock Allocation date"] == null){
              orderData["stock_allocation_date"]= "";
            }else{
              orderData["stock_allocation_date"] = excelRows[i]["Stock Allocation date"];
            }

            if(excelRows[i]["Salesman Code"] == undefined || excelRows[i]["Salesman Code"] == null){
              orderData["salesman_code"]= "";
            }else{
              orderData["salesman_code"] = excelRows[i]["Salesman Code"];
            }

            if(excelRows[i]["Beat Name"] == undefined || excelRows[i]["Beat Name"] == null){
              orderData["beat_name"]= "";
            }else{
              orderData["beat_name"] = excelRows[i]["Beat Name"];
            }

            if(excelRows[i]["MRP"] == undefined || excelRows[i]["MRP"] == null){
              orderData["mrp"]= "";
            }else{
              orderData["mrp"] = excelRows[i]["MRP"];
            }

            if(excelRows[i]["UPC"] == undefined || excelRows[i]["UPC"] == null){
              orderData["upc"]= "";
            }else{
              orderData["upc"] = excelRows[i]["UPC"];
            }

            if(excelRows[i]["Beat Seq"] == undefined || excelRows[i]["Beat Seq"] == null){
              orderData["beat_seq"]= "";
            }else{
              orderData["beat_seq"] = excelRows[i]["Beat Seq"];
            }

            if(excelRows[i]["Order date"] == undefined || excelRows[i]["Order date"] == null){
              orderData["order_date"]= "";
            }else{
              orderData["order_date"] = excelRows[i]["Order date"];
            }

            if(excelRows[i]["CBU Code"] == undefined || excelRows[i]["CBU Code"] == null){
              orderData["cbu_code"]= "";
            }else{
              orderData["cbu_code"] = excelRows[i]["CBU Code"];
            }
           arr.push(orderData);
          }

          console.log("ARR",arr);
          var arr_data = JSON.stringify(arr);

           const payload={
                  data: arr,
                //master_type: "retailer_master",
                location: ref.state.selectedLocation,
                //create: false,
                customer: "lakme"
              }
              addAnalytics('Order Upload', 'Confirm uploaded order data', payload);
            API.post('/product/product_master/v1/upload/', { param: payload })
            .then((response) => {
              console.log("responeData",response.data);


              ref.setState({
                //showBaseResponseData: true,
                showInvalidBaseItem: false,
                showInvalidTesterItem: false,
                showTesterResponseData: false,
                loading: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                //showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                //showInvalidProductItem: true,
                responseFailProductData: response.data.data,
                showRowDataErrorTester: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                //show_process_data: true,
              });

              if(response.data.success == false){
                this.seState({
                  loading_overlay: false,
                })
                ref.toggleFailed();
              }else{
                //this.Successtoggle();
                ref.setState({
                 successCreatedMessage: response.data.message,
                  loadingText: 'Data is getting Proccessed',
                  loading_overlay: true,
                })

                 axios.get('http://'+url+'/product/product_master/v1/process/',

                    {
                         headers: {
                              'Content-Type': 'application/json',
                              'Authorization' : ref.state.userName
                              
                            } 

                       }
                    )

                  .then(response => response.data)

                  .then(data => {

                     console.log("PROCESS DATA",data);
                     ref.setState({
                       //successCreatedMessage: response.data.message,
                       loading_overlay: false,
                       loading_overlay2: false,
                       loading2: false,
                       loading: false,

                      })

                      if(data.success == true){
                        ref.toggleFailed1();
                        localStorage.setItem('batch_id', data.batch_id)
                        ref.setState({
                          failCreatedMessage: 'Data is ready for planning',
                          batch_id: data.batch_id,
                          successCount: data.success_count,
                          failCount: data.failure_count,
                          btnDisabled2: false,
                          btnDisabled3: false,
                          btnDisabled1: true,

                 
                        })

                      }else{
                      ref.toggleFailed1();
                      }


                     // if (err) throw err;

                     //this.setState({ loading_overlay:false,posts: data })

                  })

                  .then(async() => {

                     //this.setState({ tableRows:this.assemblePosts(), isLoading:false })

                     //console.log(this.state.tableRows);

                  });
              }

              /*if (response.data.failure_response.length > 0) {
                ref.toggleFailed();
              } else {
                ref.toggle();
              }

              if (response.data.success_response.length > 0) {
                ref.setState({
                  show_process_data: true,
                });
              } else {
                ref.setState({
                  show_process_data: false,
                });
              } */
                this.setState({loading_overlay: false,})
        if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Secondary Master";
        }
        document.getElementById("my_file_input").style.width = "26%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
              /*this.fetchBaseData();*/
            })
            .catch(function (error) {
              
        if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Secondary Master";
        }
      
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
      });
       

        

        

       

        /*}*/
    
                        
                    };
                    reader.readAsBinaryString(this.state.file);
                    
                    //console.log("Coverted",this.dateformatHandler1(manifestPayload[0]['Order date']))
                    
                } else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        //this.ProcessExcel(data);
                    };
                    reader.readAsArrayBuffer(this.state.file);
                }
            } else {
                alert("This browser does not support HTML5.");
            }
        } else {
            alert("Please upload a valid Excel file.");
        }




         
};








  handleFileBefore() {
    /* Boilerplate to set up FileReader */

   
  if(this.state.file.name === undefined || this.state.file.name === null){
    this.setState({
      responseModal: true,
      responseModalMsg: "Select at least one File"
    });
    return false;
    }
    this.setState({
      loading: true,
      loading_overlay: true,
    });
  const ref = this;
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
      });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      /*const data = XLSX.utils.sheet_to_json(ws, {
        raw: false,
        dateNf: "YYYY-MM-DD HH:MM"
      });*/

      const data = XLSX.utils.sheet_to_json(ws,{raw:false,cellText:false, dateNF:'yyyy/mm/dd h:mm'})

      console.log("DataValues", data);
      
    var XL_row_object = XLSX.utils.sheet_to_row_object_array(
          wb.Sheets[wsname],
          { header: 1, blankRows: false }
        );
      var json_object = XL_row_object;

      
      var mandatory_field = false;
    var uploaded_file_header = json_object[0];

      /* if (this.state.selectedOption.value === "product_master") {
    var sample_file_header = Object.keys(this.state.product_master_header[0]);
    }else if (this.state.selectedOption.value === "base_pack_zone") {
    var sample_file_header = Object.keys(this.state.basepack_header[0]);
    }else if (this.state.selectedOption.value === "tester_basepack_master") {
    var sample_file_header = Object.keys(this.state.tester_header[0]);
    }else if (this.state.selectedOption.value === "bin_master") {
    var sample_file_header = Object.keys(this.state.bin_master_header[0]);
    } */

    var sample_file_header = Object.keys(this.state.basepack_header[0]);
    
    if(parseInt(uploaded_file_header.length) !== parseInt(sample_file_header.length) ){
      ref.setState({
          loading: false,
          responseModal: true,
          responseModalMsg: "Invalid Format",
                    loading_overlay: false,
        });
        /*if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
        document.getElementById("my_file_input").style.width = "26%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');*/
        return false;
    } 
    for (let i = 0; i < uploaded_file_header.length; i++){
      if (uploaded_file_header[i] !== sample_file_header[i]){
       ref.setState({
          loading: false,
          responseModal: true,
          responseModalMsg: "Invalid Format",
                    loading_overlay: false,
                    btnDisabled1: true,
                    btnDisabled: false,
        });
      return false;
      }
    }
      
      /* Update state */
      this.setState({ data: data, cols: make_cols(ws["!ref"]) }, () => {
        let invalidItems = this.state.data.filter(
          (item) => !this.validateItem(item)
        );
        /*if(invalidItems.length > 0){

          console.log("Invalid Items", invalidItems)
          this.setState({
            showInvalidItem: true,
            showResponseData: true,
            invalidItemList: invalidItems

          })
        }else{
          console.log("Valid items");
           this.setState({
            showInvalidItem: false,

          })*/

        //if (this.state.selectedOption.value === "base_pack_zone") {
          if (invalidItems.length > 0) {
            console.log(invalidItems);
            this.setState({
              showRowDataErrorBase: false,
              showRowDataErrorProduct: false,
              showRowDataErrorTester: false,
              showRowDataError: false,
              showResponseData: true,
              ErrorRowData: invalidItems,
              showResponseData: false,
              showInvalidItem: false,
              showBaseResponseData: false,
              showInvalidBaseItem: false,
              showInvalidProductItem: false,
              showInvalidTesterItem: false,
              showProductResponseData: false,
              showFetchBaseData: false,
              showFetchProductData: false,
              showFetchTesterData: false,
              showFetchBinData: false,
            });

            console.log(Object.keys(invalidItems));
            /*alert(indexOfExt(this.state.BasePackCodes, invalidItems));*/

            /*return false*/
          }

          console.log(this.state.data.length);
          var arr = [];

          for (var i = 0; i < this.state.data.length; i++) {
            // <---- Move declaration inside loop
            console.log("this.state.data[i]['Delivery Line Number']", this.state.data[i]["Delivery Line Number"])
            var orderData = {};
            /*orderData["basePackCode"] = this.state.data[i]["BasepackCode"];
            orderData["zoneName"] = this.state.data[i]["ZoneName"];
            orderData["zoneNo"] = this.state.data[i]["ZoneNo"];*/

            if(this.state.data[i]["Delivery Line Number"] == undefined || this.state.data[i]["Delivery Line Number"] == null){
              alert("Delivery Line Number cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["delivery_line_number"]= "";
            }else{
              orderData["delivery_line_number"] = this.state.data[i]["Delivery Line Number"];
            }

            if(this.state.data[i]["Outlet Order No"] == undefined || this.state.data[i]["Outlet Order No"] == null){
              alert("Outlet Order No cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
                
              orderData["outlet_order_no"]= "";
               
            }else{
              orderData["outlet_order_no"] = this.state.data[i]["outlet_order_no"];
            }

            if(this.state.data[i]["SKU7 Code"] == undefined || this.state.data[i]["SKU7 Code"] == null){
               alert("SKU7 Code cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["sku7_code"]= "";
            }else{
              orderData["sku7_code"] = this.state.data[i]["SKU7 Code"];
            }

            if(this.state.data[i]["Batch Code"] == undefined || this.state.data[i]["Batch Code"] == null){
              alert("Batch cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["batch_code"]= "";
            }else{
              orderData["batch_code"] = this.state.data[i]["Batch Code"];
            }

            if(this.state.data[i]["Distributor Code"] == undefined || this.state.data[i]["Distributor Code"] == null){
              alert("Distributor Code cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["distributor_code"]= "";
            }else{
              orderData["distributor_code"] = this.state.data[i]["Distributor Code"];
            }

            if(this.state.data[i]["Unique ID"] == undefined || this.state.data[i]["Unique ID"] == null){
              alert("Unique Id cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["unique_id"]= "";
            }else{
              orderData["unique_id"] = this.state.data[i]["Unique ID"];
            }

            if(this.state.data[i]["ASN Reference"] == undefined || this.state.data[i]["ASN Reference"] == null){
              alert("ASN Reference cannot have empty value")
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["asn_reference"]= "";
            }else{
              orderData["asn_reference"] = this.state.data[i]["ASN Reference"];
            }

            if(this.state.data[i]["RS Name"] == undefined || this.state.data[i]["RS Name"] == null){
              alert("RS Name cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["rs_name"]= "";
            }else{
              orderData["rs_name"] = this.state.data[i]["RS Name"];
            }

            if(this.state.data[i]["Retailer Code"] == undefined || this.state.data[i]["Retailer Code"] == null){
              alert("Retailer Code cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["retailer_code"]= "";
            }else{
              orderData["retailer_code"] = this.state.data[i]["Retailer Code"];
            }

            if(this.state.data[i]["Retailer HUL Code"] == undefined || this.state.data[i]["Retailer HUL Code"] == null){
              alert("Retailer HUL Code cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["retailer_hul_code"]= "";
            }else{
              orderData["retailer_hul_code"] = this.state.data[i]["Retailer HUL Code"];
            }

            if(this.state.data[i]["Retailer Name"] == undefined || this.state.data[i]["Retailer Name"] == null){
              alert("Retailer Name cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["retailer_name"]= "";
            }else{
              orderData["retailer_name"] = this.state.data[i]["Retailer Name"];
            }

            if(this.state.data[i]["Base Pack Code"] == undefined || this.state.data[i]["Base Pack Code"] == null){
              alert("BasePack Code cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["base_pack_code"]= "";
            }else{
              orderData["base_pack_code"] = this.state.data[i]["Base Pack Code"];
            }

            if(this.state.data[i]["Pkd"] == undefined || this.state.data[i]["Pkd"] == null){
              alert("PKD cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["pkd"]= "";
            }else{
              orderData["pkd"] = this.state.data[i]["Pkd"];
            }

            if(this.state.data[i]["Order Qty"] == undefined || this.state.data[i]["Order Qty"] == null){
              alert("Order Qty cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["order_qty"]= "";
            }else{
              orderData["order_qty"] = this.state.data[i]["Order Qty"];
            }

            if(this.state.data[i]["Stock Allocation date"] == undefined || this.state.data[i]["Stock Allocation date"] == null){
              alert("Stock Allocation cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["stock_allocation_date"]= "";
            }else{
              orderData["stock_allocation_date"] = this.state.data[i]["Stock Allocation date"];
            }

            if(this.state.data[i]["Salesman Code"] == undefined || this.state.data[i]["Salesman Code"] == null){
              alert("Salesman Code cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["salesman_code"]= "";
            }else{
              orderData["salesman_code"] = this.state.data[i]["Salesman Code"];
            }

            if(this.state.data[i]["Beat Name"] == undefined || this.state.data[i]["Beat Name"] == null){
              alert("Beat Name cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["beat_name"]= "";
            }else{
              orderData["beat_name"] = this.state.data[i]["Beat Name"];
            }

            if(this.state.data[i]["MRP"] == undefined || this.state.data[i]["MRP"] == null){
              alert("Mrp cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["mrp"]= "";
            }else{
              orderData["mrp"] = this.state.data[i]["MRP"];
            }

            if(this.state.data[i]["UPC"] == undefined || this.state.data[i]["UPC"] == null){
              alert("UPC cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["upc"]= "";
            }else{
              orderData["upc"] = this.state.data[i]["UPC"];
            }

            if(this.state.data[i]["Beat Seq"] == undefined || this.state.data[i]["Beat Seq"] == null){
              alert("Beat Seq cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["beat_seq"]= "";
            }else{
              orderData["beat_seq"] = this.state.data[i]["Beat Seq"];
            }

            if(this.state.data[i]["Order date"] == undefined || this.state.data[i]["Order date"] == null){
              alert("Order Date cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["order_date"]= "";
            }else{
              orderData["order_date"] = this.state.data[i]["Order date"];
            }

            if(this.state.data[i]["CBU Code"] == undefined || this.state.data[i]["CBU Code"] == null){
              alert("CBU Code cannot have empty value");
              this.setState({
                loading: false,
                loading_overlay: false,

              })
              return false;
              orderData["cbu_code"]= "";
            }else{
              orderData["cbu_code"] = this.state.data[i]["CBU Code"];
            }


            arr.push(orderData);
          }

          console.log(arr);

          this.setState({
            loading: false,
            loading_overlay: false,
          });

          this.Successtoggle();
                this.setState({
                 //successCreatedMessage: "Successfully validated. Please press<b> Process button</b> for further process.",
                 btnDisabled1: false,
                 btnDisabled: true,

                })

          return false;
          var arr_data = JSON.stringify(arr);

           const payload={
                data: arr,
                //master_type: "retailer_master",
                location: this.state.selectedLocation,
              }
            API.post('/product/product_master/v1/upload/', { param: payload })

            .then((response) => {
              console.log("responeData",response.data);


              this.setState({
                showBaseResponseData: true,
                showInvalidBaseItem: false,
                showInvalidTesterItem: false,
                showTesterResponseData: false,
                loading: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                //showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showInvalidProductItem: true,
                responseFailProductData: response.data.data,
                showRowDataErrorTester: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                show_process_data: true,
              });

              if(response.data.success == false){
                this.toggleFailed();
              }else{
                this.Successtoggle();
                this.setState({
                 successCreatedMessage: response.data.message
                })
              }

              /*if (response.data.failure_response.length > 0) {
                this.toggleFailed();
              } else {
                this.toggle();
              }

              if (response.data.success_response.length > 0) {
                this.setState({
                  show_process_data: true,
                });
              } else {
                this.setState({
                  show_process_data: false,
                });
              } */
                this.setState({loading_overlay: false,})
        if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
        document.getElementById("my_file_input").style.width = "26%";
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
              /*this.fetchBaseData();*/
            })
            .catch(function (error) {
              
        if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color =
          "transparent";
        document.getElementById("picking_label").style.display = "inline-block";
        document.getElementById("picking_label").innerHTML =
          "Select and Upload Picksheet";
        }
      
        $(".upload_error").css('display', 'none');
        $(".upload_success").css('display', 'none');
      });
       

        

        

       

        /*}*/
      });
    };

    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  }




  






  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem);
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed, modalFailed1 } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;

    const data = {
      columns: [
        {
          label: "Bin ID",

          field: "bin_id",
          sort: "asc",
        },

        {
          label: "Storage Type",

          field: "storage_type",
          sort: "asc",
        },

        {
          label: "Aisle",

          field: "aisle",
          sort: "asc",
        },

        {
          label: "Rack",

          field: "rack",
          sort: "asc",
        },

        {
          label: "Rack Type",

          field: "rack_type",
          sort: "asc",
        },

        {
          label: "Level",

          field: "level",
          sort: "asc",
        },

        {
          label: "BIN",

          field: "bin",
          sort: "asc",
        },

        {
          label: "Zone Name",

          field: "zone_name",
          sort: "asc",
        },

        {
          label: "Zone No.",

          field: "zone_no",
          sort: "asc",
        },
      ],

      rows: this.state.tableRows,
    };

    const baseData = {
      columns: [
        {
          label: "Base Pack Code",

          field: "base_pack_code",
        },

        {
          label: "zoneName",

          field: "zone_name",
        },

        {
          label: "zoneNumber",

          field: "zone_number",
        },
        {
          label: "Product Type",

          field: "productType",
        },
      ],

      rows: this.state.tableRowsBase,
    };

    const productData = {
      columns: [
        {
          label: "Company",

          field: "company",
          width: 130,
        },

        {
          label: "Brand",

          field: "brand",
          width: 130,
        },

        {
          label: "Sub Brand",

          field: "sub_brand",
          width: 150,
        },

        {
          label: "IB Sku Id",

          field: "ib_sku_id",
          width: 150,
        },

        {
          label: "IB Sku Product Name",

          field: "ib_sku_product_name",
          width: 270,
        },

        {
          label: "Base Pack Code",

          field: "base_pack_code",
          width: 130,
        },

        {
          label: "CBU Code",

          field: "cbu_code",
          width: 130,
        },

        {
          label: "Shade Code",

          field: "shade_code",
          width: 130,
        },

        {
          label: "Shade Name",

          field: "shade_name",
          width: 170,
        },

        {
          label: "Category",

          field: "category",
          width: 180,
        },

        {
          label: "Sub-Category",

          field: "sub_category",
          width: 180,
        },

        {
          label: "Price Lot",

          field: "price_lot",
          width: 180,
        },

        {
          label: "MRP",
          field: "mrp",
          width: 150,
        },

        {
          label: "UOM",
          field: "uom",
          width: 150,
        },
        {
          label: "UPC",
          field: "upc",
          width: 150,
        },

        {
          label: "Pack Size",
          field: "pack_size",
          width: 180,
        },

        {
          label: "Pack Size UO",

          field: "pack_size_uo",
          width: 150,
        },

        {
          label: "EAN",

          field: "ean",
          width: 150,
        },

        {
          label: "ICLD EAN",

          field: "icld_ean",
          width: 150,
        },

        {
          label: "Weight",

          field: "weight",
          width: 180,
        },

        {
          label: "Volume",

          field: "volume",
          width: 150,
        },

        {
          label: "ICLD Volume",

          field: "icldVolume",
          width: 150,
        },

        {
          label: "SKU7 Code",

          field: "sku7Code",
          width: 180,
        },

        {
          label: "SKU5 Code",

          field: "sku5Code",
          width: 180,
        },

        {
          label: "Offer",

          field: "offer",
          width: 180,
        },

        {
          label: "Tester",

          field: "tester",
          width: 150,
        },

        {
          label: "Storage Type",

          field: "storageType",
          width: 150,
        },

        {
          label: "Status",

          field: "status",
          width: 150,
        },

        {
          label: "Created Date Time",

          field: "createdDateTime",
          width: 180,
        },

        {
          label: "Outer Carton EAN",

          field: "outerCartonEAN",
          width: 180,
        },
        {
          label: "CPO",

          field: "cpo",
          width: 180,
        },
        {
          label: "Carton Length",

          field: "cartonLength",
          width: 180,
        },
        {
          label: "Carton Breadth",

          field: "cartonBreadth",
          width: 180,
        },
        {
          label: "Carton Height",

          field: "cartonHeight",
          width: 180,
        },
        {
          label: "Carton Volumne",

          field: "cartonVolume",
          width: 180,
        },
        {
          label: "OCLD Applicable",

          field: "ocldApplicable",
          width: 180,
        },
      ],

      rows: this.state.tableRowsProduct,
    };

    const testerData = {
      columns: [
        {
          label: "BasePack Code",

          field: "base_pack_code",
          sort: "asc",
        },

        {
          label: "Bin Address",

          field: "bin",
          sort: "asc",
        },
      ],

      rows: this.state.tableRowsTester,
    };

    return (
  
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={e => e.preventDefault()}>
              <div
                className="form__form-group col-xl-4"
                style={{ display: "none" }}
              >
                <span
                  className="form__form-group-label col-xl-4"
                  style={{ display: "none", paddingTop: 6, paddingBottom: 6 }}
                >
                  Select Master
                </span>

                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <Field
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    placeholder="Select Master"
                    value={selectedOption}
                    onChange={this.change}
                    options={[
                      { value: "bin_master", label: "Bin Master" },
                      {
                        value: "base_pack_zone",
                        label: "Basepack Zone Master",
                      },
                      { value: "product_master", label: "Product Master" },
                      {
                        value: "tester_basepack_master",
                        label: "Tester Basepack Master",
                      },
                    ]}
                  />
                </div>
              </div>

              <div
                className="form__form-group col-xl-5"
                style={{ marginBottom: "0px" }}
              >
                <div className="row">
                  <div
                    className="col-xl-12"
                    style={{ border: "1px solid #f2f4f7" }}
                  >
                    <input
                      style={{
                        paddingTop: 8,
                        height: 38,
                        color: "transparent",
                        width: "26%",
                        border: "0px",
                      }}
                      name="defaultInput"
                      component="input"
                      type="file"
                      placeholder="Default Input"
                     
                      id="my_file_input"
                      onChange={this.handleChange}
            ref={ref=> this.fileInput = ref}
                    />
                    <label for="files" id="picking_label">
                      Select and Upload Secondary Master
                    </label>
                  </div>
                  <div className="col-xl-12">
                    <span
                      style={{ display: "none", color: "red" }}
                      className="upload_error"
                    >
                      {" "}
                      Invalid file format. Please select .xls, .xlsx, .csv file
                      format{" "}
                    </span>
                    <span
                      style={{ display: "none", color: "green", marginTop: 8 }}
                      className="upload_success"
                    >
                      {" "}
                      Valid file format{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      cursor: this.state.btnDisabled ? 'not-allowed' : 'pointer',
                      backgroundColor: this.state.btnDisabled ? '#c6d5e3' : '#70bbfd',

                    }}
                    id="button_enable"
                    onClick={this.handleFileBefore}
          disabled ={this.state.btnDisabled}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Submit
                  </button>
                </ButtonToolbar>
              </div>

              
            </form>

            {this.state.showFetchBinData && (
              <div style={{ paddingLeft: "17px" }}>
                <button
                  color="primary"
                  className="download_sample_styling button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSVNew(
                      this.state.bin_master_header,
                      "Bin_Master_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                <div className="notes" style={{ paddingTop: "15px" }}>
                  <p style={{ marginBottom: "13px", fontSize: "15px" }}>
                    <b>Note</b> : 1. All fields are mandatory.
                  </p>
                  <p
                    style={{
                      marginBottom: "13px",
                      fontSize: "15px",
                      paddingLeft: "46px",
                    }}
                  >
                    2. UOM for Bin Depth, Bin Width and Bin Height is in
                    Centimetre.
                  </p>
                  <p
                    style={{
                      marginBottom: "13px",
                      fontSize: "15px",
                      paddingLeft: "46px",
                    }}
                  >
                    3. UOM for Bin Volume is in Centimetre Cube.
                  </p>
                </div>
              </div>
            )}



           
              <div style={{ paddingLeft: "17px" }}>
                <button
                  color="primary"
                  className="download_sample_styling button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSVNew(
                      this.state.basepack_header,
                      "Secondary_Order_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                
              </div>
           

            {this.state.showFetchProductData && productData && (
              <div style={{ paddingLeft: "17px" }}>
                <button
                  color="primary"
                  className="download_sample_styling button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSVNew(
                      this.state.product_master_header,
                      "Product_Master_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                <div className="notes" style={{ paddingTop: "15px" }}>
                  <p style={{ marginBottom: "13px", fontSize: "15px" }}>
                    <b>Note</b> : Please download the latest Product Master from
                    TP and Upload here. (No changes required).
                  </p>
                </div>
              </div>
            )}

            {this.state.showFetchTesterData && productData && (
              <div style={{ paddingLeft: "17px" }}>
                <button
                  color="primary"
                  className="download_sample_styling button_enable "
                  style={{
                    backgroundColor: "#fff",
                    marginTop: 4,
                    marginBottom: 7,
                    fontWeight: "500",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                  }}
                  onClick={(e) =>
                    exportToCSVNew(
                      this.state.tester_header,
                      "Tester_Basepack_Zone_Master_Template"
                    )
                  }
                >
                  Sample Template
                </button>
                <div className="notes" style={{ paddingTop: "15px" }}>
                  <p style={{ marginBottom: "13px", fontSize: "15px" }}>
                    <b>Note</b> : 1. All fields are mandatory.
                  </p>
                  <p
                    style={{
                      marginBottom: "13px",
                      fontSize: "15px",
                      paddingLeft: "46px",
                    }}
                  >
                    2. Only upload the basepacks, having the Tester Flag as
                    "Yes" in Product Master.
                  </p>
                  <p
                    style={{
                      marginBottom: "13px",
                      fontSize: "15px",
                      paddingLeft: "46px",
                    }}
                  >
                    3. Assign a fresh/empty bin to the new basepack.
                  </p>
                  <p
                    style={{
                      marginBottom: "13px",
                      fontSize: "15px",
                      paddingLeft: "46px",
                    }}
                  >
                    4. Make a new entry for assigning a fresh bin to the
                    existing basepack.
                  </p>
                </div>
              </div>
            )}

            <div className="form__form-group col-xl-8">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      cursor: this.state.btnDisabled1 ? 'not-allowed' : 'pointer',
                      backgroundColor: this.state.btnDisabled1 ? '#c6d5e3' : '#70bbfd',
                    }}
                    id="button_enable"
                    onClick={this.handleFile}
          disabled ={this.state.btnDisabled1}
                  >
                    {this.state.loading2 && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Process
                  </button>

                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      display: 'none',
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      cursor: this.state.btnDisabled2 ? 'not-allowed' : 'pointer',
                      backgroundColor: this.state.btnDisabled2 ? '#c6d5e3' : '#70bbfd',
                    }}
                    id="button_enable"
                    onClick={this.togglePressView}
          disabled ={this.state.btnDisabled2}
                  >
                    {this.state.loading2 && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </button>

                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      cursor: this.state.btnDisabled3 ? 'not-allowed' : 'pointer',
                      backgroundColor: this.state.btnDisabled3 ? '#c6d5e3' : '#70bbfd',
                    }}
                    id="button_enable"
                    onClick={this.downloadError}
          disabled ={this.state.btnDisabled3}
                  >
                    {this.state.loading2 && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Download Error
                  </button>


                 
                </ButtonToolbar>

                

                



                 
              </div>
          </CardBody>

          {/*this.state.showZoneConfigCard &&
          <CardBody style={{ marginTop: 20 }}>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
        {<input
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zonecode"
                  type="text"
                  placeholder="Zone Code"
                  id="config_zonecode"
                  onChange={this.configOnChangeHandler}
        />}
        <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zonecode"
                  placeholder="Configuration"
                  id="config_zonecode"
                  onChange={this.configOnChangeHandler}
                >
                <option value="" disabled selected hidden>-Select zone-</option>
                {this.state.zoneOptions.map(zone =>
                  <option value={zone.value}>{zone.label}</option>
        )}
                </select>
              </div>
            </div>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
        <input
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zonename"
                  type="text"
                  placeholder="Zone Name"
                  id="config_zonename"
                  onChange={this.configOnChangeHandler}
        />
              </div>
            </div>

            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
                <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zonetype"
                  placeholder="Type"
                  id="config_zonetype"
                  onChange={this.configOnChangeHandler}
                >
                <option value="0" disabled selected hidden>-Select Type-</option>
        {this.state.zoneTypeDropdown.map(zone =>
                  <option value={zone.id}>{zone.zone_type}</option>
        )}
                </select>
              </div>
            </div>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "0px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
                <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_zoneconfig"
                  placeholder="Configuration"
                  id="config_zoneconfig"
                  onChange={this.configOnChangeHandler}
                >
                <option value="0" disabled selected hidden>-Select Config-</option>
                {this.state.zoneConfigDropdown.map(config =>
                  <option value={config.id}>{config.config_code}</option>
        )}
                </select>
              </div>
            </div>
      <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
                <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_basepackcode"
                  placeholder="Configuration"
                  id="config_basepackcode"
                  onChange={this.configOnChangeHandler}
                >
                <option value="0" disabled selected hidden>-Select Basepack-</option>
                {this.state.configBaskPackDropdown.map(basepack =>
                  <option value={basepack}>{basepack}</option>
        )}
                </select>
              </div>
            </div>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <div
                className="form__form-group-field"
                style={{ display: "contents" }}
              >
                <select
                  style={{
                    height: 38,
                    width: "100%",
                    border: "1px solid #bfbfbf",
                  }}
                  name="config_producttype"
                  placeholder="Configuration"
                  id="config_producttype"
                  onChange={this.configOnChangeHandler}
                >
                <option value="" disabled selected hidden>-Select Product Type-</option>
                <option value="0">Saleable</option>
        <option value="1">Carton</option>
        <option value="2">Tester</option>
                </select>
              </div>
            </div>
            <div
              className="form__form-group col-xl-3"
              style={{ display: "inline-flex", marginBottom: "10px" }}
            >
              <ButtonToolbar className="form__button-toolbar">
                <button
                  color="primary"
                  className="btn-sm button_enable "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                  }}
                  id="button_enable"
                  onClick={this.createZoneConfig}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Create
                </button>
              </ButtonToolbar>
            </div>
          </CardBody>
      */}
          {this.state.showRowDataError && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  {" "}
                  Please upload file again.{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>BIN ID</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["Bin"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok show_bin_proceed"
                      onClick={this.openConfirm}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button>
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>BIN ID</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailBinData.failure_response.length > 0 &&
                    this.state.responseFailBinData.failure_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{ color: "red" }}>{item.message}</td>
                        </tr>
                      )
                    )}

                  {this.state.responseSuccessBinData.success_response.length >
                    0 &&
                    this.state.responseSuccessBinData.success_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.bin_address}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          )}

          {/*{
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text">BIN MASTER</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.posts, "BinMaster")}>Download Excel</Button>
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            data={data}
          />
          </CardBody>

          )}*/}

          {this.state.showRowDataErrorBase && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  Please upload file again{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Base Pack Code</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["Basepack Code"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidBaseItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    {" "}
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.openConfirm}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button>{" "}
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Base Pack Code</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailBaseData.failure_response.length >
                    0 &&
                    this.state.responseFailBaseData.failure_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "red" }}>{item.message}</td>
                        </tr>
                      )
                    )}

                  {this.state.responseSuccessBaseData.success_response.length >
                    0 &&
                    this.state.responseSuccessBaseData.success_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          )}

          {/*{
            this.state.showFetchBaseData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> BASE PACK MASTER</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsBase, "BasepackMaster")}>Download Excel</Button>
            </div>
            <MDBDataTable
            striped
            bordered
            hover
            data={baseData}
          />
          </CardBody>

          )}*/}

          {this.state.showRowDataErrorProduct && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  {" "}
                  Please upload file again{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>LB SKU ID</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["LB SKU ID"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidProductItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.openConfirm}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed
                    </Button>
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>HUL Code</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailProductData.length >
                    0 &&
                    this.state.responseFailProductData.map(
                      (item, index) => (
                        <tr>
                          <td>{item.id}</td>
                          {item.success == false &&
                             <td style={{ color: "red"}}>{item.message}</td>
                          }
                          {item.success == true &&
                             <td style={{ color: "green"}}>{item.message}</td>
                          }
                        </tr>
                      )
                    )}

                </tbody>
              </Table>
            </CardBody>
          )}

          {/*{
            this.state.showFetchProductData  && productData &&(

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> Product Master</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsProduct, "ProductMaster")}>Download Excel</Button>
            </div>

             {this.state.loadingGRNData && 
                <div style={{width: '2300%', textAlign: 'center', paddingTop: 22}}>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" , fontSize: 18 }}
                      />
                  </div>
              }
            
         <MDBDataTable
            scrollX
            striped
            bordered
            data={productData}
          />

          </CardBody>

          )}*/}

          {this.state.showRowDataErrorTester && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <h4
                  style={{ color: "red", fontWeight: "bold" }}
                  className="subhead red-text"
                >
                  {" "}
                  Please upload file again{" "}
                </h4>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>LB SKU ID</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.ErrorRowData.length > 0 &&
                    this.state.ErrorRowData.map((item, index) => (
                      <tr>
                        <td>{item["LB SKU ID"]}</td>
                        <td style={{ color: "red" }}> Column is missing </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showInvalidTesterItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                {this.state.show_process_data && (
                  <h4
                    style={{ color: "red", fontWeight: "bold" }}
                    className="subhead red-text"
                  >
                    <Button
                      style={{
                        backgroundColor: "#24d6a3",
                        color: "#fff",
                        marginLeft: 12,
                      }}
                      className="modal_ok"
                      onClick={this.openConfirm}
                    >
                      {this.state.loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Proceed1
                    </Button>
                  </h4>
                )}
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>LB SKU ID</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailTesterData.failure_response.length >
                    0 &&
                    this.state.responseFailTesterData.failure_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "red" }}>{item.message}</td>
                        </tr>
                      )
                    )}

                  {this.state.responseSuccessTesterData.success_response
                    .length > 0 &&
                    this.state.responseSuccessTesterData.success_response.map(
                      (item, index) => (
                        <tr>
                          <td>{item.basePackCode}</td>
                          <td style={{ color: "green" }}>{item.message}</td>
                        </tr>
                      )
                    )}
                </tbody>
              </Table>
            </CardBody>
          )}

          {/* {
            this.state.showFetchTesterData  && productData &&(

          <CardBody style={{marginTop: 20}}>
            <div className="table_header">
              <h4 style={{fontWeight: 'bold', width: '80%' , paddingTop: 10, float: 'left'}} className="subhead red-text"> Tester BasePack Master</h4>
              <Button style={{marginBottom: 0, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => exportToCSV(this.state.postsTester, "TesterFile")}>Download Excel</Button>
            </div>

             {this.state.loadingGRNData && 
                <div style={{width: '2300%', textAlign: 'center', paddingTop: 22}}>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" , fontSize: 18 }}
                      />
                  </div>
              }
            
         <MDBDataTable
            scrollX
            striped
            bordered
            data={testerData}
          />

          </CardBody>

          )}*/}
        </Card>
        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}
          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              className="modal_cancel"
              onClick={this.togglePressCancel}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalFailed1}
          toggle={this.toggleFailed1}
          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed1}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: this.state.failCount > 0 ? "red" : "green" }}
            />
            <h4>{this.state.failCreatedMessage} </h4>
            <span><strong> Total Count : {this.state.totalCount}</strong><strong style={{paddingLeft: 20}}> Pass : {this.state.successCount}</strong> <strong style={{paddingLeft: 20}}> Fail : {this.state.failCount} </strong> </span>
          </div>
          <ButtonToolbar className="modal__footer">
             <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel1}
            >
              Ok
            </Button>
            {/*<Button
              style={{ backgroundColor: "#24d6a3", color: "#fff", marginLeft: 10 }}
              className="modal_ok"
              onClick={this.togglePressView}
            >
              View
            </Button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff", marginLeft: 10 }}
              className="modal_ok"
              onClick={this.downloadError}
            >
              Download Error
            </Button>*/}
          </ButtonToolbar>

          <ButtonToolbar className="modal__footer">
            
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully validated. Please press <b> Process button</b> for further process.</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.SuccesstoggleCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={ConfirmModal}
          toggle={this.ConfirmToggle}
          style={{ maxWidth: 456 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.ConfirmToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4 style={{ fontSize: 18 }}> Are you sure you want to proceed?</h4>
            <br />
            <h3 style={{ fontSize: 17 }}>
              <strong> NOTE: </strong> Duplicate entries will be updated if you
              proceed.{" "}
            </h3>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{
                backgroundColor: "#24d6a3",
                color: "#fff",
                marginRight: 8,
              }}
              className="modal_ok"
              onClick={this.processData}
            >
              Ok
            </Button>
            <button
              className="modal_cancel"
              onClick={this.ConfirmToggle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>
    
    <Modal
          isOpen={this.state.responseModal}
          toggle={this.responseModalToggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.responseModalToggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>{this.state.responseModalMsg}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: 'black'}} className="modal_ok"  onClick={this.responseModalToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>
    
        <Modal
          isOpen={modalFailed1}
          toggle={this.toggleFailed1}
          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed1}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failCreatedMessage} </h4>
            <span><strong> Success Count : {this.state.successCount}</strong> <strong style={{paddingLeft: 20}}> Failure Count : {this.state.failCount} </strong> </span>
          </div>
          <ButtonToolbar className="modal__footer">
             <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel1}
            >
              Ok
            </Button>
          </ButtonToolbar>

          <ButtonToolbar className="modal__footer">
            
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));